/* raw layout hash: _role-permissions-security-policies-layout:4b51f2c7e6502d36dc640529b8b5b227a6aea089e8037225c1e50718bdcbbba1 */
import React from 'react';
import AppShell from './AppShell.jsx';
import { LAYOUT_MENUS } from './layoutMenus.js';

// Layout "_role-permissions-security-policies-layout" — renders its page content through the router outlet.
export default function RolePermissionsSecurityPoliciesLayout() {
  return <AppShell layoutName="_role-permissions-security-policies-layout" menu={LAYOUT_MENUS['_role-permissions-security-policies-layout']} />;
}
